import { isNil } from '@flowio/is';
import { RequestPaymentParameters } from '../types';

export default function getInitPaymentMethodData(
  requestOptions: RequestPaymentParameters,
): io.flow.v0.unions.PaymentMethodData | undefined {
  if (isNil(requestOptions.data.paymentMethod)) {
    return undefined;
  }
  switch (requestOptions.data.paymentMethod.id) {
    case 'klarna': return {
      type: 'init_klarna',
    };
    case 'ideal': return {
      type: 'init_ideal',
    };
    case 'sofort': return {
      type: 'init_sofort',
    };
    case 'paypal': return {
      type: 'init_paypal',
    };
    case 'applepay': return {
      type: 'init_applepay',
    };
    case 'bancontact': return {
      type: 'init_bancontact',
    };
    case 'twint': return {
      type: 'init_twint',
    };
    case 'przelewy24': return {
      type: 'init_przelewy24',
    };
    case 'mobilepay': return {
      type: 'init_mobilepay',
    };
    case 'vipps': return {
      type: 'init_vipps',
    };
    case 'kcp_creditcard': return {
      type: 'init_kcp_creditcard',
    };
    case 'grabpay': return {
      type: 'init_grabpay',
    };

    default: return undefined;
  }
}
